












import { messageInfo } from '../../util/messageUtil'

export default {
  data() {
    return {
      messageInfo
    }
  }
}
